import styles from './BtnGroup.less?modules';
import ButtonML from '@/components/button_ml/ButtonML';
import { history } from 'umi';

const BtnGroup = (props) => {
  const { handleSave, handleCancel } = props || {};
  const { editable } = props.location.query;

  return (
    <div className={styles.btn_contain}>
      <ButtonML
        size="large"
        value="保存"
        fontsize="16px"
        onClick={() => handleSave()}
        disabled={String(editable) === 'false'}
      />
      <ButtonML
        size="large"
        value="取消"
        fontsize="16px"
        onClick={() => handleCancel()}
      />
      <ButtonML
        size="large"
        value="返回"
        // width="106px"
        // height="46px"
        fontsize="16px"
        onClick={() => history.go(-1)}
      />
    </div>
  );
};

export default BtnGroup;
